export const GET_LIST_REQUEST_ERROR_MESSAGE = 'Error fetching wishlists. Please try again.';
export const ADD_DEAL_REQUEST_ERROR_MESSAGE = 'Error adding product to wishlist. Please try again.';
export const REMOVE_DEAL_REQUEST_ERROR_MESSAGE = 'Error removing product from wishlist. Please try again.';
export const CREATE_LIST_REQUEST_ERROR_MESSAGE = 'Error creating wishlist. Please try again.';
export const UPDATE_LIST_REQUEST_ERROR_MESSAGE = 'Error updating wishlist. Please try again.';
export const DUPLICATE_LIST_REQUEST_ERROR_MESSAGE = 'Error duplicating wishlist. Please try again.';
export const DELETE_LIST_REQUEST_ERROR_MESSAGE = 'Error deleting wishlist. Please try again.';
export const WISHLISTS_HEADER_REQUEST_ERROR_MESSAGE = 'Error fetching wishlist data. Please try again.';
